import request from '@/utils/request'
import { getScopedToken } from '@/utils/auth'

export function loginWithCandidate(data) {
  return request({
    url: '/portal-api/zhongyi/auth/login',
    method: 'POST',
    data
  })
}

export function fetchScoreList(scope) {
  return request({
    url: '/portal-api/zhongyi/score/list',
    method: 'GET',
    params: scope
      ? {
          scope
        }
      : {}
  })
}

export function fetchScoreDetail(candidateId) {
  return request({
    url: '/portal-api/zhongyi/score/detail',
    method: 'GET',
    params: {
      candidateId
    }
  })
}

export function fetchCertificateDetail(certNo) {
  return request({
    url: '/portal-api/zhongyi/certificate/detail',
    method: 'GET',
    params: {
      certNo
    }
  })
}

function buildPostAbilityAuthHeaders() {
  const token = getScopedToken('postAbility')
  return token
    ? {
        Authorization: `Bearer ${token}`
      }
    : {}
}

export function loginWithPostAbilityCandidate(data) {
  return request({
    url: '/portal-api/zhongyi/post-ability/auth/login',
    method: 'POST',
    data,
    headers: buildPostAbilityAuthHeaders()
  })
}

export function fetchPostAbilityScoreList() {
  return request({
    url: '/portal-api/zhongyi/post-ability/score/list',
    method: 'GET',
    headers: buildPostAbilityAuthHeaders()
  })
}

export function fetchPostAbilityScoreDetail(candidateId) {
  return request({
    url: '/portal-api/zhongyi/post-ability/score/detail',
    method: 'GET',
    params: {
      candidateId
    },
    headers: buildPostAbilityAuthHeaders()
  })
}
